<div class="container table-container">    
    <mat-toolbar>
        <span>Tipos de documentos</span>
        <span class="sgd-spacer"></span>
        <button (click)="onAddDocumentType()" mat-flat-button>Nuevo</button>
    </mat-toolbar>
    <table mat-table [dataSource]="dataSource" >

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="acciones"></th>
            <td mat-cell *matCellDef="let element" class="acciones">
                <button mat-icon-button (click)="onDeleteDocumentType(element.id)" matTooltip="Eliminar" type="button">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
